import { useState, useContext, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Typography, ChooseColor, CapacityCard } from 'mobily-ui-library/lib'
import { GlobalContext } from '../../../context/GlobalContext'

import './ProductVariants.scss';

interface ProductVariantsProps {
    getVariantHandler: any;
    attributeId: string;
    attributeName: any;
    attributeOptions: any;
    enabledAttributeOptions: any;
    selectedButtons: any;
    optionColors: any;
    isVariantError: boolean;
}

const ProductVariants = (props: ProductVariantsProps) => {
    const { attributeOptions, attributeName, optionColors, getVariantHandler, isVariantError } = props;

    const { state }: any = useContext(GlobalContext);
    const { rtl } = state;
    const { t } = useTranslation();

    const [selectedVariant, setSelectedVariant] = useState<any>({});
    const [selectedButtons, setSelectedButtons] = useState(props.selectedButtons);
    const [enabledAttributeOptions, setEnabledAttributeOptions] = useState(props.enabledAttributeOptions);

    useEffect(() => {
        if (props.enabledAttributeOptions !== enabledAttributeOptions) {
            setEnabledAttributeOptions(props.enabledAttributeOptions)
        }

        if (props.selectedButtons !== selectedButtons) {
            setSelectedButtons(props.selectedButtons)
        }

        if (isVariantError) {
            setSelectedVariant(selectedButtons);
        }
    }, [enabledAttributeOptions, props, selectedButtons, isVariantError])

    const enabledAttributes = enabledAttributeOptions[attributeName];
    const attribute = attributeName;

    return (
        <div className={'attribute_list'}>
            <Typography rtl={rtl} className='choose_color_title'>
                {t(`${attribute}`)}
            </Typography>

            {selectedVariant[attribute] === '' && (
                <Typography rtl={rtl} className='please_select_choice'>
                    {t('please_select_one_choice')}
                </Typography>
            )}

            <div className='colorCard_container'>
                {attributeOptions.map((item: any, i: number) => {

                    const id = `${item.replace(' ', '-').toLowerCase()}-${attribute}`;
                    const isOutOfStock = enabledAttributes ? !enabledAttributes.includes(item) : true;

                    if (attribute.toLowerCase().includes('color')) {
                        return (
                            <ChooseColor
                                key={i}
                                id={id}
                                rtl={rtl}
                                width="165px"
                                subtitle={isOutOfStock ? t('no_stock') : ""}
                                selected={selectedButtons[attribute] === item}
                                onClick={() => getVariantHandler(attribute, item)}
                                isOutOfStock={isOutOfStock}
                                backgroundColor={optionColors && optionColors[i]}
                                nameOfColor={item}
                            />
                        );
                    }

                    return (
                        <CapacityCard
                            key={i}
                            id={id}
                            capacitySizeText={item}
                            productStock={isOutOfStock ? t('no_stock') : ""}
                            onClick={() => getVariantHandler(attribute, item)}
                            stock={true}
                            isOutOfStock={isOutOfStock}
                            selected={selectedButtons[attribute] === item}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default ProductVariants;
